/* Peak Moto help chat.
 * Answers come from Peak Moto Ops (Help Chat) through the App Proxy; this file
 * draws the chat and runs the step-by-step parts: finding an order, working
 * out a size from the product's size chart, and a delivery date from Peak
 * Promise. Config comes from snippets/pmo-help-chat.liquid.
 */
(function () {
  "use strict";
  var root = document.getElementById("pmo-hc");
  var cfgEl = document.getElementById("pmo-hc-config");
  if (!root || !cfgEl || root.dataset.ready) return;
  root.dataset.ready = "1";
  // Hidden until PMO says the chat is on (Settings -> Chat Bot).
  root.classList.add("pmo-hc--off");
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var P = CFG.proxy || "/apps/peakmoto";
  var SITE = "https://peakmotogear.com.au";

  // ---------- little helpers ----------
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var ss = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem("pmo.hc." + k)); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem("pmo.hc." + k, JSON.stringify(v)); } catch (e) {} }
  };
  var DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MON = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  function day(iso) {
    var m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return "";
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12));
    return DOW[d.getUTCDay()] + " " + d.getUTCDate() + " " + MON[d.getUTCMonth()];
  }
  function range(a, b) { var x = day(a), y = day(b); return !y || x === y ? x : x + " - " + y; }
  function api(path, body) {
    var opts = body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } };
    return fetch(P + path, opts).then(function (r) { return r.json(); });
  }
  // Counted in PMO -> Help Chat -> Insights (sizes worked out, delivery dates given).
  function note(type) { api("/help/event", { type: type }).catch(function () {}); }
  function pdpVariant() {
    var u = new URLSearchParams(location.search).get("variant");
    if (u) return u;
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (f && f.value) || (CFG.product && CFG.product.variant) || null;
  }

  // Picks a variant's options on the product page itself (Pipeline's option
  // buttons, dropdown links or selects), one option at a time, since picking
  // one can redraw the others. Gives back the first picker it used (to show
  // it) when the page ends up on that variant, false when it doesn't.
  var OPTION_SEL = 'input[type="radio"][name^="options["], select[name^="options["] option, form[action*="/cart/add"] input[type="radio"], form[action*="/cart/add"] select option, a[data-popout-option]';
  function optName(el) {
    if (el.tagName === "A") {
      var box = el.closest("popout-select, .select-popout"), input = box && box.querySelector('input[name^="options["]');
      return input ? input.name : "";
    }
    return (el.tagName === "OPTION" ? el.parentElement.name : el.name) || "";
  }
  function optValue(el) { return el.tagName === "A" ? el.getAttribute("data-value") || "" : el.value; }
  function selectOnPage(p, v) {
    if (!v || !CFG.product || CFG.product.handle !== p.handle) return false;
    var first = null;
    (v.options || []).forEach(function (val, i) {
      var want = "options[" + (p.options || [])[i] + "]", hit = null, any = null;
      document.querySelectorAll(OPTION_SEL).forEach(function (el) {
        if (hit || el.closest(".pmo-hc, pmo-size-guide") || optValue(el) !== val) return;
        if (optName(el) === want) hit = el; else if (!any) any = el;
      });
      var el = hit || any;
      if (!el) return;
      if (!first) first = el.tagName === "OPTION" ? el.parentElement : el.closest("popout-select, .select-popout") || el;
      if (el.tagName === "OPTION") {
        if (el.parentElement.value !== el.value) { el.parentElement.value = el.value; el.parentElement.dispatchEvent(new Event("change", { bubbles: true })); }
      } else if (!el.checked) el.click();
    });
    var id = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!id || String(id.value) !== String(v.id)) return false;
    return first || true;
  }

  // ---------- the shell ----------
  root.innerHTML =
    '<button type="button" class="pmo-hc__launch" aria-haspopup="dialog" aria-controls="pmo-hc-panel">' +
    '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 3h14a2.5 2.5 0 0 1 2.5 2.5v8.5a2.5 2.5 0 0 1-2.5 2.5h-7.5L6 21v-4.5H5A2.5 2.5 0 0 1 2.5 14V5.5A2.5 2.5 0 0 1 5 3z"/><path d="M7 8h10M7 11.5h5"/></svg><span>Help</span></button>' +
    '<button type="button" class="pmo-hc__hide" aria-label="Hide the Help button" title="Hide">&times;</button>' +
    '<div class="pmo-hc__toast" role="status" hidden></div>' +
    '<section class="pmo-hc__panel" id="pmo-hc-panel" role="dialog" aria-label="Peak Moto help">' +
    '<div class="pmo-hc__head"><div><strong>Peak Moto</strong><span>Orders, sizing and delivery, sorted</span></div>' +
    '<button type="button" class="pmo-hc__restart" title="Start again"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg><span>Start again</span></button>' +
    '<button type="button" class="pmo-hc__x" aria-label="Close help">&times;</button></div>' +
    (CFG.product ? '<div class="pmo-hc__ctx">Looking at: ' + esc(CFG.product.title) + "</div>" : "") +
    '<div class="pmo-hc__log" aria-live="polite"></div>' +
    '<form class="pmo-hc__compose" autocomplete="off"><button type="button" class="pmo-hc__back" hidden aria-label="Go back a step">&#8617; Back</button>' +
    '<label style="position:absolute;left:-9999px" for="pmo-hc-say">Message</label><input id="pmo-hc-say" placeholder="Ask about an order, a size, delivery..."><button type="submit" class="pmo-hc__send">Send</button></form>' +
    '<div class="pmo-hc__foot">Messages passed to the crew are answered within one business day.</div>' +
    '<div class="pmo-hc__confirm" role="alertdialog" aria-modal="true" aria-labelledby="pmo-hc-cf-t" aria-describedby="pmo-hc-cf-d" hidden><div class="pmo-hc__confirm-card">' +
    '<strong id="pmo-hc-cf-t">Start again?</strong>' +
    '<p id="pmo-hc-cf-d">This wipes the chat so far - everything above, including any sizes, delivery dates or order details, and your postcode. You can\'t get it back.</p>' +
    '<div class="pmo-hc__confirm-btns"><button type="button" class="pmo-hc__btn" data-hc-restart-yes>Yes, start again</button><button type="button" class="pmo-hc__chip" data-hc-restart-no>Keep chatting</button></div>' +
    "</div></div></section>";
  var log = $(".pmo-hc__log"), say = $("#pmo-hc-say"), backBtn = $(".pmo-hc__back");
  var PLACE = "Ask about an order, a size, delivery...";

  var S = { awaiting: null, postcode: ss.get("postcode"), order: null, lastAsk: "", lastUnanswered: "", avoid: null };
  var started = false;

  function open() {
    root.classList.add("pmo-hc--open");
    ss.set("open", true);
    if (!started) { started = true; if (!restore()) greet(); }
    setTimeout(function () { say.focus(); }, 50);
  }
  function close() { root.classList.remove("pmo-hc--open"); ss.set("open", false); $(".pmo-hc__launch").focus(); }
  $(".pmo-hc__launch").addEventListener("click", open);
  $(".pmo-hc__x").addEventListener("click", close);

  // ---------- start again ----------
  // Asks first, since it can't be undone; then clears the chat, the steps
  // Back would retrace, and what this visit has remembered, and says hello again.
  var confirmBox = $(".pmo-hc__confirm");
  function askRestart() { confirmBox.hidden = false; confirmBox.querySelector("[data-hc-restart-no]").focus(); }
  function hideRestart() { confirmBox.hidden = true; $(".pmo-hc__restart").focus(); }
  function restart() {
    confirmBox.hidden = true;
    gen++; turn++;
    history.length = 0; backBtn.hidden = true;
    log.innerHTML = "";
    S = { awaiting: null, postcode: null, order: null, lastAsk: "", lastUnanswered: "", avoid: null };
    try { sessionStorage.removeItem("pmo.hc.log"); sessionStorage.removeItem("pmo.hc.postcode"); } catch (e) {}
    say.value = ""; setPlace();
    greet();
    setTimeout(function () { say.focus(); }, 50);
  }
  $(".pmo-hc__restart").addEventListener("click", askRestart);
  confirmBox.addEventListener("click", function (e) {
    if (e.target.closest("[data-hc-restart-yes]")) restart();
    else if (e.target.closest("[data-hc-restart-no]") || e.target === confirmBox) hideRestart();
  });

  // ---------- hiding the bubble; Help in the header and the menu ----------
  // Anyone who doesn't want the floating button can hide it (remembered in
  // this browser). The chat stays one tap away: a chat icon in the desktop
  // header, and "Help & chat" in the phone menu.
  var ls = {
    get: function (k) { try { return localStorage.getItem("pmo.hc." + k); } catch (e) { return null; } },
    set: function (k, v) { try { if (v == null) localStorage.removeItem("pmo.hc." + k); else localStorage.setItem("pmo.hc." + k, v); } catch (e) {} }
  };
  var ICON = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 3h14a2.5 2.5 0 0 1 2.5 2.5v8.5a2.5 2.5 0 0 1-2.5 2.5h-7.5L6 21v-4.5H5A2.5 2.5 0 0 1 2.5 14V5.5A2.5 2.5 0 0 1 5 3z"/><path d="M7 8h10M7 11.5h5"/></svg>';
  function onPhone() {
    var m = document.querySelector(".header__mobile");
    return m ? getComputedStyle(m).display !== "none" : window.innerWidth < 990;
  }
  if (ls.get("bubble") === "off") root.classList.add("pmo-hc--nobubble");
  var toastT;
  $(".pmo-hc__hide").addEventListener("click", function () {
    ls.set("bubble", "off");
    root.classList.add("pmo-hc--nobubble");
    var t = $(".pmo-hc__toast");
    t.innerHTML = "<span>No worries! " + (onPhone() ? "You'll find <b>Help</b> at the top of the menu" : "Help is the chat icon at the top of the page") + " whenever you need it.</span><button type=\"button\" data-hc-undo>Undo</button><button type=\"button\" class=\"pmo-hc__toast-x\" data-hc-tclose aria-label=\"Close this message\">&times;</button><i class=\"pmo-hc__toast-bar\" aria-hidden=\"true\"></i>";
    t.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.hidden = true; }, 8000);
  });
  $(".pmo-hc__toast").addEventListener("click", function (e) {
    if (e.target.closest("[data-hc-tclose]")) { clearTimeout(toastT); this.hidden = true; return; }
    if (!e.target.closest("[data-hc-undo]")) return;
    ls.set("bubble", null);
    root.classList.remove("pmo-hc--nobubble");
    this.hidden = true;
  });
  function addEntries() {
    var desk = document.querySelector(".header__desktop__buttons");
    if (desk && !desk.querySelector(".pmo-hc-entry")) {
      var cart = desk.querySelector(".navlink--cart");
      var d = document.createElement("div");
      d.className = "header__desktop__button pmo-hc-entry";
      d.innerHTML = '<a href="#help" class="navlink" title="Help">' + ICON + '<span class="visually-hidden">Help</span></a>';
      desk.insertBefore(d, cart ? cart.closest(".header__desktop__button") : null);
      d.querySelector("a").addEventListener("click", function (e) { e.preventDefault(); open(); });
    }
    // Phones: "Help" at the top of the menu, beside the close button.
    var top = document.querySelector("#header-menu .drawer__top__left");
    if (top && !document.querySelector("#header-menu .pmo-hc-entry")) {
      var it = document.createElement("a");
      it.href = "#help";
      it.className = "pmo-hc-entry pmo-hc-drawer-help";
      it.innerHTML = ICON.replace('width="22" height="22"', 'width="20" height="20"') + "<span>Help</span>";
      top.appendChild(it);
      it.addEventListener("click", function (e) {
        e.preventDefault();
        var x = document.querySelector('#header-menu [data-drawer-toggle="hamburger"]');
        if (x) x.click();
        setTimeout(open, 250);
      });
    }
  }
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !root.classList.contains("pmo-hc--open")) return;
    if (!confirmBox.hidden) hideRestart(); else close();
  });

  // ---------- messages ----------
  var history = [], gen = 0, turn = 0;
  function scroll() { log.scrollTop = log.scrollHeight; }
  function me(text) {
    var m = document.createElement("div");
    m.className = "pmo-hc__msg pmo-hc__msg--me";
    m.innerHTML = '<div class="pmo-hc__bubble">' + esc(text) + "</div>";
    log.appendChild(m); scroll();
  }
  function bot(html, delay) {
    var mine = gen;
    var t = document.createElement("div");
    t.className = "pmo-hc__typing"; t.innerHTML = "<i></i><i></i><i></i>";
    log.appendChild(t); scroll();
    return new Promise(function (res) {
      setTimeout(function () {
        t.remove();
        var m = document.createElement("div");
        m.className = "pmo-hc__msg pmo-hc__msg--bot";
        m.innerHTML = '<div class="pmo-hc__bubble">' + html + "</div>";
        if (mine === gen) { log.appendChild(m); scroll(); }
        res(m);
      }, delay == null ? 350 : delay);
    });
  }
  // Thinking while a request is out; replaced by the answer. If they've
  // moved on before it lands, the late answer is dropped.
  function wait(promise) {
    var t = document.createElement("div"), mine = turn;
    t.className = "pmo-hc__typing"; t.innerHTML = "<i></i><i></i><i></i>";
    log.appendChild(t); scroll();
    var stale = function () { return new Promise(function () {}); };
    return promise.then(function (x) { t.remove(); return mine === turn ? x : stale(); }, function (e) { t.remove(); if (mine !== turn) return stale(); throw e; });
  }
  function chips(list, onPick) {
    if (!list || !list.length) return;
    var c = document.createElement("div");
    c.className = "pmo-hc__chips";
    list.forEach(function (item) {
      var label = typeof item === "string" ? item : item.label;
      var b = document.createElement("button");
      b.type = "button"; b.className = "pmo-hc__chip"; b.textContent = label;
      // Sold out: crossed out, and picking it leads to "tell me when it's back".
      if (item && item.off) { b.className += " pmo-hc__chip--off"; b.setAttribute("aria-label", label + " - sold out, get an email when it's back"); }
      b.addEventListener("click", function () {
        snap(); c.classList.add("pmo-hc__chips--used"); me(label);
        if (onPick) onPick(item); else handle(label);
      });
      c.appendChild(b);
    });
    log.appendChild(c); scroll();
  }
  function links(list) {
    if (!list || !list.length) return "";
    return '<div class="pmo-hc__links">' + list.map(function (l) { return '<a href="' + esc(l.url) + '">' + esc(l.label) + " &rarr;</a>"; }).join("") + "</div>";
  }
  function homeChips() {
    var base = ["Track my order", "Find my size", "When will it arrive?", "Returns policy", "Message the crew"];
    return CFG.product ? ["What size am I in this?", "When would this arrive?", "What protection does it have?", "Track my order", "Message the crew"] : base;
  }
  // A dead end: the crew, plus the usual options so nobody's left stuck.
  function deadEnd(first, noCrew) {
    var list = [];
    (first || []).concat(["Message the crew"], homeChips()).forEach(function (c) {
      if (list.indexOf(c) > -1) return;
      if (noCrew && c === "Message the crew") return;
      list.push(c);
    });
    chips(list);
  }
  // After a product answer: its delivery date, or the usual options.
  function moreFor(p) {
    var list = ["When would it arrive?"];
    homeChips().forEach(function (c) { if (!/arrive|size am I in this|the crew/i.test(c)) list.push(c); });
    chips(list, function (x) { if (x === "When would it arrive?") return pickVariant(p); handle(x); });
  }
  function setPlace(p) { say.placeholder = p || PLACE; }

  // Back a step: every customer action saves where the chat was first.
  function frozen(n) { return n.classList.contains("pmo-hc__chips--used") || !!n.querySelector("button[type=submit][disabled]"); }
  function snap() {
    turn++;
    history.push({ count: log.children.length, frozen: Array.prototype.map.call(log.children, frozen), state: JSON.parse(JSON.stringify(S)), place: say.placeholder });
    if (history.length > 40) history.shift();
    backBtn.hidden = false;
  }
  backBtn.addEventListener("click", function () {
    var h = history.pop();
    if (!h) return;
    gen++;
    while (log.children.length > h.count) log.lastElementChild.remove();
    Array.prototype.forEach.call(log.children, function (n, i) {
      if (!h.frozen[i]) { n.classList.remove("pmo-hc__chips--used"); n.querySelectorAll("button[type=submit][disabled]").forEach(function (b) { b.disabled = false; }); }
    });
    S = h.state; say.placeholder = h.place;
    backBtn.hidden = !history.length;
    scroll(); say.focus();
  });

  $(".pmo-hc__compose").addEventListener("submit", function (e) {
    e.preventDefault();
    var v = say.value.trim();
    if (!v) return;
    say.value = ""; snap(); me(v); handle(v);
  });

  function greet() {
    api("/help").then(function (r) {
      bot((r && r.html) || "<p>Hey! How can we help?</p>", 200).then(function () { chips(homeChips()); });
    }, function () {
      bot("<p>Hey! How can we help?</p>", 200).then(function () { chips(homeChips()); });
    });
  }

  // ---------- routing ----------
  var NAV = /^(something else|start over|menu)$/i;
  function handle(text) {
    var t = String(text).trim();
    if (/message the (team|crew)|talk to (the )?(crew|team|someone|a person)|speak to/i.test(t)) { S.awaiting = null; return handoff(); }
    if (t === "Try again" && !S.awaiting) { S.order = null; return startOrder(); }
    if (NAV.test(t)) { S.awaiting = null; setPlace(); return bot("<p>What else can I help you with?</p>").then(function () { chips(homeChips()); }); }
    if (t === "Change postcode" && S.eta) { S.postcode = null; ss.set("postcode", null); return askPostcode(); }
    if (/^Try another (size|colour|option)$/.test(t) && S.eta) return pickVariant(S.eta.product);
    if (t === "A different product") return askProductName("eta");
    if (/^(Measure again|Use different measurements)$/.test(t) && S.size) return askMeasure(S.size);
    if (/\b(fit consult(ation)?|book (a |an )?(fit|consult|video|call|time|appointment))\b/i.test(t)) return bookConsult();
    if (/^complete (the|my) kit$/i.test(t) && S.size && S.size.p) return completeKit(S.size.p);
    // Waiting for a product name, order number, email or postcode, but they've
    // asked something else instead ("Do you alter gear?"): answer that.
    if (S.awaiting && looksLikeQuestion(t) && !(S.awaiting === "email" && /@/.test(t)) && !(/^(order|postcode)$/.test(S.awaiting) && /\d{3,}/.test(t))) {
      S.awaiting = null; S.pendingSize = S.pendingEta = false; S.pendingFact = null; setPlace();
    }
    if (S.awaiting === "order") return orderNumber(t);
    if (S.awaiting === "email") return orderEmail(t);
    if (S.awaiting === "postcode") return postcode(t);
    if (S.awaiting === "productName") return productName(t);
    S.lastAsk = t;
    // "How about the Fiona jacket?" straight after a product answer asks the
    // same question about a different product.
    var also = t.match(/^(?:and\s+)?(?:how|what)\s+about\s+(.+?)\??$|^(?:and|same\s+(?:for|with))\s+(?:the\s+)?(.+?)\??$/i);
    if (also && S.lastFact) return ask(also[1] || also[2], { fact: S.lastFact, noPage: true, also: true });
    var num = t.match(/(?:#|\bpm\s?)(\d{4,6})\b/i);
    if (num) { S.order = "PM" + num[1]; return askEmail(); }
    return ask(t, {});
  }

  function looksLikeQuestion(t) {
    return /\?\s*$/.test(t) || /^(do|does|did|can|could|how|what|what's|whats|is|are|was|where|when|why|who|will|would|should|i'm|im|i am|i|my|hi|hello|hey|thanks|thank you)\b/i.test(t) || t.split(/\s+/).length > 6;
  }
  // The same test PMO uses to decide a question is a product hunt.
  var RANGE_ASK = /\b(do|does|did) (you|u|peak moto|ya) (guys )?(sell|stock|have|carry|do|got|make|offer)\b|\bhave (you|u) got\b|\b(you|u) (guys )?(sell|stock|carry)\b|\blooking for\b|\bwhere (can|do) i (get|buy|find)\b|\bin stock\b|\bany\b.*\b(in|available)\b/i;
  var SHOP_ASK = /\b(?:lay-?\s?by|afterpay|zip\s?pay|paypal|gift ?cards?|price ?match(?:ing)?|discounts?|promo(?: code)?s?|coupons?|events?|workshops?|group rides?|returns?|refunds?|exchanges?|warrant(?:y|ies)|alterations?|hem(?:ming)?|holds?|deposits?|try[- ]?ons?|fit consult(?:ation)?s?|parking|click (?:and|&) collect|pick ?ups?|delivery|shipping|postage|express|international|overseas|students?|clubs?|trade[- ]?ins?|buy[- ]?backs?|garage sale|invoices?|opening|hours|open on)\b/i;
  function ask(q, o) {
    var body = { q: q, page: CFG.page, avoid: S.avoid };
    if (o.pick) body.pick = o.pick;
    if (o.fact) body.fact = o.fact;
    if (o.also) body.also = true;
    if (o.product) body.product = o.product;
    // The product the chat is already about - the one just discussed, or the
    // page they're on - so "is it waterproof?" follows on from the last answer.
    var ctx = S.lastProduct || (CFG.product && CFG.product.handle);
    if (ctx && !o.noPage && !o.product) body.context = ctx;
    // "Do you have heated vests?": say we're looking while the range is searched.
    // Not for shop questions that start the same way ("Do you have lay-by?").
    var req = api("/help/ask", body);
    var lead = !o.pick && !o.fact && !o.product && RANGE_ASK.test(q) && !SHOP_ASK.test(q)
      ? bot("<p>Sure, let me check our range for you. One sec!</p>", 250) : Promise.resolve();
    return lead.then(function () { return wait(req); }).then(function (r) { return show(r, q); }, function () {
      return bot("<p>Sorry, I can't reach our answers right now. You can still message the crew.</p>").then(function () { deadEnd(); });
    });
  }

  function show(r, q) {
    r = r || {};
    if (r.product && r.product.handle) { S.lastProduct = r.product.handle; S.lastFact = r.fact || null; }
    var act = r.action || "";
    if (r.kind === "answer" && act === "order") return startOrder();
    if (r.kind === "answer" && act === "change") return startChange();
    if (r.kind === "answer" && act === "size") return startSize();
    if (r.kind === "answer" && act === "eta") return startEta();
    if (r.kind === "answer" && act === "handoff" && !r.product) return handoff();
    if (r.kind === "answer") {
      S.avoid = r.answerId ? { answerId: r.answerId, variant: r.variant } : null;
      return bot((r.html || "") + links(r.links), 0).then(function () {
        if (act === "handoff") return deadEnd();
        chips((r.followUps || []).concat(["Something else"]));
      });
    }
    if (r.kind === "choose") {
      return bot(r.html, 0).then(function () {
        chips((r.options || []).map(function (o) { return { label: o.title, id: o.id }; }), function (o) { ask("", { pick: o.id }); });
      });
    }
    if (r.kind === "choose_product") {
      // Confirm the product first; typing another name searches again.
      S.awaiting = "productName"; S.pendingFact = r.fact; setPlace("Product name");
      return bot("<p>Could you confirm which one?</p>", 0).then(function () {
        chips((r.options || []).map(function (o) { return { label: o.title, handle: o.handle }; }).concat([{ label: "Other", other: true }]), function (o) {
          if (o.other) { S.awaiting = "productName"; S.pendingFact = r.fact; setPlace("Product name"); return bot("<p>No worries - type the product name and I'll look it up.</p>"); }
          S.awaiting = null; setPlace(); ask("", { fact: r.fact, product: o.handle });
        });
      });
    }
    if (r.kind === "need_product") {
      S.awaiting = "productName"; S.pendingFact = r.fact; setPlace("Product name");
      return bot(r.html, 0);
    }
    if (r.kind === "products") {
      return bot((r.html || "") + '<div class="pmo-hc__card">' + (r.products || []).map(function (p) {
        return '<div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="pmo-hc__sub">' + esc(p.vendor || "") + "</div></div>";
      }).join("") + links(r.links) + "</div>", 0).then(function () { chips((r.followUps || []).concat(["Something else"])); });
    }
    if (r.kind === "noproduct") {
      S.lastUnanswered = q;
      return bot(r.html, 0).then(handoff).then(function () { deadEnd(null, true); });
    }
    S.lastUnanswered = q;
    return bot(r.html || "<p>Hmm, that one's got me stumped. Want me to pass it to the crew?</p>", 0).then(function () { deadEnd(r.followUps); });
  }

  function productName(t) {
    S.awaiting = null; setPlace();
    if (S.pendingSize) { S.pendingSize = false; return findProduct(t, startSizeFor); }
    if (S.pendingEta) { S.pendingEta = false; return findProduct(t, pickVariant); }
    return ask(t, { fact: S.pendingFact, noPage: true });
  }

  // ---------- products by name (for size and delivery) ----------
  function loadProduct(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + "?view=pmo-help").then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); });
  }
  // The shop's own search (the same results as the search page, via
  // templates/search.pmo-help.liquid), re-ordered so products with the
  // customer's words in their name come first: "disc lock" puts the Alarm
  // Disc Lock ahead of every Quad Lock that only shares the word "lock".
  // Results that only matched on their description are left out.
  function searchProducts(text) {
    var words = String(text).toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.length > 3 ? w.replace(/s$/, "") : w; });
    return fetch("/search?q=" + encodeURIComponent(text) + "&type=product&view=pmo-help").then(function (r) { return r.text(); }).then(function (t) {
      return (JSON.parse(t).results || []).map(function (p, i) {
        var title = String(p.title || "").toLowerCase(), type = String(p.type || "").toLowerCase();
        var more = (String(p.vendor || "") + " " + (p.tags || []).join(" ")).toLowerCase(), s = 0, all = true;
        words.forEach(function (w) {
          var re = new RegExp("(^|[^a-z0-9])" + w);
          if (re.test(title)) s += 3;
          else { all = false; if (re.test(type)) s += 2; else if (re.test(more)) s += 1; }
        });
        if (all && words.length) s += 2;
        if (!p.available) s -= 0.5;
        return { p: p, s: s, i: i };
      }).filter(function (x) { return x.s > 0 || !words.length; }).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (x) { return x.p; });
    });
  }
  function findProduct(text, next) {
    var listen = function () { S.awaiting = "productName"; S[next === startSizeFor ? "pendingSize" : "pendingEta"] = true; };
    return wait(searchProducts(text)).then(function (all) {
      var ps = all.slice(0, 5);
      if (!ps.length) {
        // Shows up in PMO -> Help Chat -> Not answered yet.
        api("/help/missed", { q: text, page: CFG.page }).catch(function () {});
        listen();
        return bot("<p>I couldn't find a product called that. Try the name as it's written on the site, like \"Horizon 3 H2O\", or the brand.</p>");
      }
      if (ps.length === 1) return withProduct(ps[0].handle, next);
      // Still listening for a name, so typing another product searches again.
      listen(); setPlace("Product name");
      var more = all.length > ps.length ? '<div class="pmo-hc__links"><a href="/search?q=' + encodeURIComponent(text) + '&type=product">See all search results &rarr;</a></div>' : "";
      return bot("<p>Could you confirm which one?</p>" + more, 0).then(function () {
        chips(ps.map(function (p) { return { label: p.title, handle: p.handle }; }).concat([{ label: "Other", other: true }]), function (o) {
          if (o.other) { listen(); setPlace("Product name"); return bot("<p>No worries - type the product name, the brand, or what it's for and I'll search again.</p>"); }
          S.awaiting = null; S.pendingSize = S.pendingEta = false; setPlace(); withProduct(o.handle, next);
        });
      });
    }, function () { return bot("<p>I couldn't search right now - try again in a moment.</p>"); });
  }
  function withProduct(handle, next) {
    return wait(loadProduct(handle)).then(function (p) { S.lastProduct = p.handle; return next(p); }, function () { return bot("<p>I couldn't open that product just now. Try again in a moment.</p>"); });
  }
  function askProductName(kind) {
    S.awaiting = "productName"; S.pendingSize = kind === "size"; S.pendingEta = kind === "eta";
    setPlace("Product name");
    return bot("<p>Which product are you looking at? Type its name and I'll find it.</p>");
  }

  // ---------- order ----------
  function startOrder() {
    if (S.order) return askEmail();
    S.awaiting = "order"; setPlace("e.g. PM10482");
    return bot("<p>Let's find it. What's your order number? It starts with PM - you'll find it in your confirmation email.</p>");
  }
  function orderNumber(t) {
    var raw = t.replace(/\s+/g, "").toUpperCase().replace(/^#/, "");
    if (!/^[A-Z]*\d+$/.test(raw)) return bot("<p>That doesn't look quite like an order number. It's PM and then numbers, like PM10482.</p>");
    S.order = /^\d+$/.test(raw) ? "PM" + raw : raw;
    return askEmail();
  }
  // "Can I change my order?" - only while nothing has gone out. Needs the
  // order first, so it runs the lookup if it hasn't been done in this chat.
  function startChange() {
    S.wantChange = true;
    if (S.orderChange) return changeVerdict(S.orderChange);
    if (S.order) return askEmail();
    S.awaiting = "order"; setPlace("e.g. PM10482");
    return bot("<p>Let's check whether it's gone out yet. What's your order number? It starts with PM - you'll find it in your confirmation email.</p>");
  }
  function changeVerdict(c) {
    S.wantChange = false;
    if (c.state === "open") return bot("<p><b>Good news - it hasn't gone out yet</b>, so we can still change or cancel it. Message the crew now with what you'd like changed - the sooner the better.</p>").then(handoff);
    if (c.state === "partly") return bot("<p>Part of it has <b>already gone out</b>, so those items can't be changed - but the rest hasn't left yet. Message the crew now with what you'd like changed.</p>").then(handoff);
    if (c.state === "cancelled") return bot("<p>That order was cancelled, so there's nothing to change. Want to ask the crew about it?</p>").then(function () { deadEnd(); });
    return bot("<p>It's <b>already on its way</b>, so it can't be changed now. Once it arrives you can exchange or return it - exchanges are free.</p>").then(function () { deadEnd(["How do I start a return or exchange?"]); });
  }
  function askEmail() {
    S.awaiting = "email"; setPlace("you@example.com");
    return bot("<p>Got it. And the email you ordered with?</p>").then(function () {
      if (CFG.customer && CFG.customer.email) chips([CFG.customer.email]);
    });
  }
  function orderEmail(t) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)) return bot("<p>That email doesn't look quite right - mind checking it?</p>");
    S.awaiting = null; setPlace();
    return wait(api("/help/order", { order: S.order, email: t })).then(function (r) {
      if (!r || !r.ok) {
        return bot("<p>" + esc((r && r.message) || "We couldn't find that order.") + "</p>").then(function () { deadEnd(["Try again"]); });
      }
      var o = r.order;
      var html = "<p>Found it! Here's where everything's up to:</p><div class=\"pmo-hc__card\"><div><h4>Order " + esc(o.name) + "</h4>" + (o.cancelled ? '<div class="pmo-hc__sub">This order was cancelled.</div>' : "") + "</div>";
      (o.items || []).forEach(function (it) {
        html += '<div class="pmo-hc__item"><div class="pmo-hc__item-head">' + (it.imageUrl ? '<img src="' + esc(it.imageUrl) + '" alt="" loading="lazy">' : "") +
          "<div><b>" + esc(it.title) + "</b>" + (it.variantTitle ? '<div class="pmo-hc__sub">' + esc(it.variantTitle) + (it.quantity > 1 ? " &middot; " + it.quantity : "") + "</div>" : "") + "</div></div>";
        if (it.steps && it.steps.length) {
          html += '<ol class="pmo-steps">' + it.steps.map(function (s) {
            return '<li class="pmo-step ' + (s.done ? "pmo-step--done" : "pmo-step--todo") + '">' + esc(s.label) + (s.detail ? '<span class="pmo-step__detail">' + esc(s.detail) + "</span>" : "") + "</li>";
          }).join("") + "</ol>";
        } else if (it.headline) html += "<div>" + esc(it.headline) + "</div>";
        (it.tracking || []).forEach(function (tr) { html += tr.url ? '<a href="' + esc(tr.url) + '">Track: ' + esc(tr.label) + " &rarr;</a>" : '<div class="pmo-hc__sub">' + esc(tr.label) + "</div>"; });
        html += "</div>";
      });
      if (o.supplierNote) html += '<div class="pmo-hc__note">' + esc(o.supplierNote) + "</div>";
      if (o.change && o.change.state === "open") html += '<div class="pmo-hc__sub">Nothing has gone out yet, so it can still be changed.</div>';
      if (o.fullUrl) html += '<a href="' + esc(o.fullUrl) + '">See full order status &rarr;</a>';
      html += "</div>";
      S.orderChange = o.change || null;
      return bot(html, 0).then(function () {
        if (S.wantChange && o.change) return changeVerdict(o.change);
        chips(["Can I change my order?", "Something else"]);
      });
    }, function () { return bot("<p>I can't look up orders right now. Please try again in a minute, or message the crew.</p>").then(function () { deadEnd(["Try again"]); }); });
  }

  // ---------- size ----------
  function startSize() {
    if (CFG.product) return withProduct(CFG.product.handle, startSizeFor);
    return askProductName("size");
  }
  function calc() {
    if (window.PmoSizeCalc) return Promise.resolve(window.PmoSizeCalc);
    return new Promise(function (res, rej) {
      var s = document.createElement("script"); s.src = CFG.calcUrl; s.onload = function () { res(window.PmoSizeCalc); }; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function startSizeFor(p) {
    var chart = p.chart && p.chart.charts && p.chart.charts.find(function (c) { return c.calc && c.calc.fields && c.calc.fields.length; });
    if (!chart) {
      note("size_nochart");
      // Nothing to measure here: point them at the product page, not the crew.
      var si = -1, sizes = [];
      (p.options || []).forEach(function (o, i) { if (si < 0 && /size/i.test(o)) si = i; });
      if (si > -1) (p.variants || []).forEach(function (v) { var x = (v.options || [])[si]; if (x && sizes.indexOf(x) < 0) sizes.push(x); });
      var sized = sizes.length > 1, list = sizes.length > 8 ? sizes.length + " sizes" : sizes.slice(0, -1).join(", ") + " and " + sizes[sizes.length - 1];
      return bot("<p>" + (sized ? "There's no size chart for the <b>" + esc(p.title) + "</b> - it comes in " + esc(list) + ", and the product page has the details on each." : "The <b>" + esc(p.title) + "</b> comes in one size, so there's nothing to measure - the product page has all the details.") +
        '</p><div style="margin-top:10px"><a class="pmo-hc__cta" href="' + esc(p.url) + '">View the ' + esc(p.title) + "</a></div>").then(function () { moreFor(p); });
    }
    S.size = { p: p, chart: chart };
    // Measurements they've already given (here, in a size guide or on a
    // collection page) answer it straight away.
    var known = RIDER.full(chart.calc);
    if (known) return calc().then(function (K) { return sizeResult(S.size, known, K, "cm", true); }, function () { return askMeasure(S.size); });
    return askMeasure(S.size);
  }
  function askMeasure(sz) {
    var c = sz.chart.calc, id = "pmo-hc-m" + Date.now();
    var fields = c.fields.map(function (f, i) {
      return '<label>' + esc(f.label) + '<input id="' + id + "-" + i + '" inputmode="decimal" required></label>';
    }).join("");
    return bot("<p>Let's get you sorted. Pop in your body measurements for the <b>" + esc(sz.p.title) + "</b> - over thin clothes is best:</p>" +
      '<form class="pmo-hc__card pmo-hc__form" id="' + id + '"><div style="display:flex;justify-content:space-between;align-items:center;gap:8px"><b style="font-size:14px">Your measurements</b>' +
      '<span class="pmo-hc__unit" role="group" aria-label="Units"><button type="button" data-u="cm" aria-pressed="true">cm</button><button type="button" data-u="in" aria-pressed="false">in</button></span></div>' +
      '<div class="pmo-hc__row2">' + fields + '</div><button class="pmo-hc__btn" type="submit">Find my size</button>' +
      '<a href="' + esc(CFG.measureUrl) + '" style="font-size:14px">How to measure &rarr;</a></form>').then(function (m) {
      var form = m.querySelector("form"); if (!form) return;
      var unit = "cm";
      RIDER.partial(c).forEach(function (v, i) { var x = form.querySelector("#" + id + "-" + i); if (x && v != null) x.value = v; });
      form.querySelectorAll("[data-u]").forEach(function (b) {
        b.addEventListener("click", function () { unit = b.dataset.u; form.querySelectorAll("[data-u]").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); });
      });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var raw = c.fields.map(function (f, i) { return parseFloat(String(form.querySelector("#" + id + "-" + i).value).replace(",", ".")); });
        if (raw.some(function (v) { return !isFinite(v) || v <= 0; })) return;
        snap(); form.querySelector("button[type=submit]").disabled = true;
        me(c.fields.map(function (f, i) { return f.label + " " + raw[i] + " " + unit; }).join(", "));
        var cm = raw.map(function (v) { return unit === "in" ? Math.round(v * 2.54 * 10) / 10 : v; });
        calc().then(function (K) { sizeResult(sz, cm, K, unit); }, function () { bot("<p>The size calculator didn't load. Try again in a moment.</p>"); });
      });
      form.querySelector("input").focus();
    });
  }
  function norm(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9½]/g, ""); }
  function variantFor(p, size) {
    var want = norm(size);
    var vs = (p.variants || []).filter(function (v) { return (v.options || []).some(function (o) { return norm(o) === want; }); });
    if (!vs.length) vs = (p.variants || []).filter(function (v) { return norm(v.title).indexOf(want) > -1; });
    // Charts name pants "AU 20 / US 18 Petite" while the product's options are
    // "AU 20" and "Petite 27"": match the size on any of its names, and the length.
    if (!vs.length) {
      var lm = String(size || "").trim().match(/^(.*?)[\s\/]+(extra short|short|petite|standard|regular|long|tall|extra long)$/i);
      var names = (lm ? lm[1] : String(size || "")).split("/").map(norm).filter(Boolean), len = lm ? norm(lm[2]) : "";
      vs = (p.variants || []).filter(function (v) {
        var os = (v.options || []).map(norm);
        return os.some(function (o) { return names.indexOf(o) > -1; }) && (!len || os.some(function (o) { return o.indexOf(len) === 0; }));
      });
    }
    if (!vs.length) return null;
    var cur = CFG.product && CFG.product.handle === p.handle ? String(pdpVariant()) : null;
    var curV = cur && (p.variants || []).find(function (v) { return String(v.id) === cur; });
    if (curV) {
      var keep = vs.find(function (v) { return v.options.every(function (o, i) { return norm(o) === want || o === curV.options[i] || norm(curV.options[i]) === want; }); });
      if (keep) return keep;
    }
    return vs.find(function (v) { return v.available; }) || vs[0];
  }
  // The size guide's own working, so the chat says exactly what the size
  // guide on the product page would: the size, a strip per measurement
  // showing where it sits, and, when measurements point at different
  // sizes, which ones and why. On pants listed by leg length ("AU 12
  // Petite") the inseam picks the length, never the size.
  var SG = (function () {
    var TO_CM = { cm: 1, "cm-ft": 1, "ft-cm": 1, mm: 0.1, in: 2.54 };
    var LENGTH_RE = /^(.*?)[\s\/]+(extra short|short|petite|standard|regular|long|tall|extra long|L\d{2}"?)$/i;
    var LEG_RE = /\b(inseam|inside leg|leg length|leg)\b/i;
    var CONSULT_URL = "/pages/fit-consultation";
    function n(s) { return String(s || "").trim().toLowerCase(); }
    function r1(x) { return Math.round(x * 10) / 10; }
    function rowsOf(t) {
      if (t.direction !== "row") return t.rows;
      var out = [];
      t.rows.forEach(function (row, r) { row.forEach(function (c, i) { (out[i] = out[i] || [])[r] = c; }); });
      return out;
    }
    function splitLength(label) {
      var m = String(label == null ? "" : label).trim().match(LENGTH_RE);
      return m && m[1] ? { size: m[1].trim(), length: m[2].trim() } : null;
    }
    function baseSize(label) { var x = splitLength(label); return n(x ? x.size : label); }
    function areaName(label) {
      var a = String(label || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/\b(circumference|girth|measurement)\b/g, "").replace(/\s+/g, " ").trim();
      return a || String(label || "").toLowerCase();
    }
    function cellBand(cell) {
      if (!cell) return null;
      var f = TO_CM[cell.u] || 1;
      var v = String(cell.v == null ? "" : cell.v).replace(/,/g, ".").split("-").map(function (x) { return parseFloat(x) * f; })
        .filter(function (x) { return isFinite(x); }).sort(function (a, b) { return a - b; });
      return v.length ? [v[0], v[v.length - 1]] : null;
    }
    // Which sizes the measurements span, each one on its own.
    function span(K, table, calc, values, size) {
      var rows = rowsOf(table), scol = calc.size || 0, order = [], labels = {};
      rows.slice(1).forEach(function (row) {
        var v = row[scol] && row[scol].v, b = baseSize(v), x = splitLength(v);
        if (order.indexOf(b) < 0) order.push(b);
        if (!labels[b]) labels[b] = x ? x.size : String(v);
      });
      var each = [];
      calc.fields.forEach(function (f, i) {
        if (order.length < rows.length - 1 && LEG_RE.test(f.label)) return;
        var one = K.recommend(table, { size: calc.size, fields: [f] }, [values[i]], "regular");
        if (one.size) each.push({ label: f.label, size: labels[baseSize(one.size)] || one.size, rank: order.indexOf(baseSize(one.size)) });
      });
      var ranks = each.map(function (x) { return x.rank; }).filter(function (x) { return x > -1; });
      var lo = Math.min.apply(null, ranks), hi = Math.max.apply(null, ranks), mine = order.indexOf(baseSize(size));
      if (mine > -1) { lo = Math.min(lo, mine); hi = Math.max(hi, mine); }
      return ranks.length && hi > lo ? { sizes: order.slice(lo, hi + 1), from: labels[order[lo]], to: labels[order[hi]], each: each, wide: hi - lo >= 2 } : null;
    }
    function spanHtml(size, sp) {
      if (!sp) return "";
      var list = sp.each.map(function (x) { return esc(areaName(x.label)) + " <b>" + esc(x.size) + "</b>"; }).join(", ");
      var mine = baseSize(size);
      var other = sp.each.filter(function (x) { return baseSize(x.size) !== mine; });
      var roomy = other.filter(function (x) { return !LEG_RE.test(x.label); }).map(function (x) { return esc(areaName(x.label)); });
      var long = other.some(function (x) { return LEG_RE.test(x.label); });
      var after = [];
      if (roomy.length) after.push("it may feel roomy in the " + roomy.join(" and "));
      if (long) after.push("the legs may be a little long");
      var drivers = sp.each.filter(function (x) { return baseSize(x.size) === mine; });
      var byLeg = drivers.filter(function (x) { return LEG_RE.test(x.label); }).length;
      var why = !drivers.length || byLeg === 0 ? " so it isn't tight anywhere" : byLeg === drivers.length ? " so the legs are long enough" : " so it isn't tight anywhere and the legs are long enough";
      list = list.charAt(0).toUpperCase() + list.slice(1);
      var html = '<div class="pmo-hc__split"><b>You sit between sizes ' + esc(sp.from) + " and " + esc(sp.to) + ".</b> " + list + ". " +
        "We've recommended " + esc(splitLength(size) ? splitLength(size).size : size) + why + (after.length ? ", but " + after.join(" and ") : "") + ".";
      if (sp.wide) html += ' Different brands and cuts suit different proportions, so if you\'re unsure, <a href="' + CONSULT_URL + '">book a free fit consultation</a> and we\'ll help you choose.';
      return html + "</div>";
    }
    function stripsHtml(calc, size, sp, table, values, units) {
      var rows = rowsOf(table);
      if (!rows || rows.length < 3 || !values || !values.length) return "";
      var scol = calc.size || 0;
      var green = [baseSize(size)].concat(sp ? sp.sizes : []);
      var show = function (cm) { return units === "in" ? r1(cm / 2.54) + "in" : r1(cm) + "cm"; };
      var range = function (b) { return b[0] <= 0 ? "up to " + show(b[1]) : b[0] === b[1] ? show(b[1]) : (units === "in" ? r1(b[0] / 2.54) + "–" + r1(b[1] / 2.54) + "in" : r1(b[0]) + "–" + r1(b[1]) + "cm"); };
      var html = '<div class="pmo-hc__strips">';
      calc.fields.forEach(function (f, i) {
        var v = Number(values[i]); if (!(v > 0)) return;
        var bands = rows.slice(1).map(function (row) { return cellBand(row[f.col]); });
        var segs = [];
        var lens = LEG_RE.test(f.label) ? rows.slice(1).map(function (row) { return splitLength(row[scol] && row[scol].v); }) : null;
        if (lens && lens.every(function (x) { return x; })) {
          var mine = splitLength(size), byLen = {};
          lens.forEach(function (x, k) {
            var b = bands[k]; if (!b) return;
            var g = byLen[x.length] || (byLen[x.length] = { lo: b[0], hi: b[1], raw: [b[0], b[1]], sz: x.length, sug: false });
            g.lo = Math.min(g.lo, b[0]); g.hi = Math.max(g.hi, b[1]); g.raw = [g.lo, g.hi];
            if (mine && n(mine.length) === n(x.length)) g.sug = true;
          });
          segs = Object.keys(byLen).map(function (k) { return byLen[k]; }).sort(function (a, b) { return a.lo - b.lo; });
        } else rows.slice(1).forEach(function (row, k) {
          var b = bands[k]; if (!b) return;
          var lab = String(row[scol] && row[scol].v != null ? row[scol].v : "").trim(), x = splitLength(lab), sz = x ? x.size : lab;
          var lo = b[0], hi = b[1];
          if (lo === hi) {
            var prev = bands[k - 1], next = bands[k + 1];
            lo = prev ? (prev[1] + b[0]) / 2 : null; hi = next ? (b[1] + next[0]) / 2 : null;
            var step = hi != null ? hi - b[1] : lo != null ? b[0] - lo : 2;
            if (lo == null) lo = b[0] - step; if (hi == null) hi = b[1] + step;
          } else if (lo <= 0) {
            var nx = bands[k + 1]; lo = nx && nx[1] > nx[0] ? b[1] - (nx[1] - nx[0]) : b[1] - 4;
          }
          var last = segs[segs.length - 1], on = green.indexOf(baseSize(lab)) > -1;
          if (last && last.raw[0] === b[0] && last.raw[1] === b[1]) { if (on) last.sug = true; return; }
          if (last && last.sz === sz) { last.hi = Math.max(last.hi, hi); last.raw = [Math.min(last.raw[0], b[0]), Math.max(last.raw[1], b[1])]; if (on) last.sug = true; return; }
          segs.push({ lo: lo, hi: hi, raw: b, sz: sz, sug: on });
        });
        if (segs.length < 2) return;
        for (var q = 1; q < segs.length; q++) {
          var a = segs[q - 1], c = segs[q];
          if (c.lo !== a.hi && c.lo > a.lo && c.hi > a.hi) { var mid = (a.hi + c.lo) / 2; a.hi = mid; c.lo = mid; }
        }
        var si = [], vi = 0, best = Infinity;
        segs.forEach(function (x, k) {
          if (x.sug) si.push(k);
          var d = v < x.lo ? x.lo - v : v > x.hi ? v - x.hi : 0; if (d < best) { best = d; vi = k; }
        });
        var from = Math.max(0, Math.min.apply(null, si.concat([vi])) - 1), to = Math.min(segs.length - 1, Math.max.apply(null, si.concat([vi])) + 1);
        var win = segs.slice(from, to + 1);
        var lo0 = Math.min(win[0].lo, v), hi0 = Math.max(win[win.length - 1].hi, v), pad = (hi0 - lo0) * 0.06 + 0.5, l = lo0 - pad, w = hi0 + pad - l;
        var inSug = win.some(function (x) { return x.sug && v >= x.lo && v <= x.hi; });
        var sugs = win.filter(function (x) { return x.sug; });
        var full = sugs.map(function (x) { return x.sz + " " + range(x.raw); }).join(" · "), right = full;
        if (sugs.length > 1) {
          var fs = sugs[0], zs = sugs[sugs.length - 1], fl = fs.sz.split(" / ")[0], zl = zs.sz.split(" / ")[0], pre = (fl.match(/^[^\d]*\s/) || [""])[0];
          if (pre && zl.indexOf(pre) === 0) zl = zl.slice(pre.length);
          right = win.indexOf(zs) - win.indexOf(fs) === sugs.length - 1 ? fl + "–" + zl + " " + range([fs.raw[0], zs.raw[1]]) : sugs.map(function (x) { return x.sz.split(" / ")[0]; }).join(" & ");
        }
        html += '<div><div class="pmo-hc__strip-head"><b>' + esc(String(f.label).replace(/ circumference/i, "")) + " " + show(v) + '</b><span title="' + esc(full) + '">' + esc(right) + "</span></div>" +
          '<div class="pmo-hc__strip">' + win.map(function (x) {
            var left = (x.lo - l) / w * 100, width = (x.hi - x.lo) / w * 100, s1 = x.sz.split(" / ")[0], s2 = s1.replace(/^[A-Za-z]+\s+(?=\d)/, "");
            return '<i class="pmo-hc__step' + (x.sug ? " is-sug" : "") + '" style="left:' + left.toFixed(2) + "%;width:" + width.toFixed(2) + '%" title="' + esc(x.sz + " " + range(x.raw)) + '"><b data-full="' + esc(x.sz) + '" data-s1="' + esc(s1) + '" data-s2="' + esc(s2) + '">' + esc(x.sz) + "</b></i>";
          }).join("") +
          '<i class="pmo-hc__pin' + (inSug ? "" : " is-out") + '" style="left:' + ((v - l) / w * 100).toFixed(2) + '%"></i></div></div>';
      });
      return html + "</div>";
    }
    // A size name too long for its piece of the strip shortens: "XL / AU 16" to "XL", then "EU 42" to "42".
    function fit(root) {
      Array.prototype.forEach.call(root.querySelectorAll(".pmo-hc__step b[data-full]"), function (b) {
        var room = b.parentNode.clientWidth - 2; if (!room) return;
        b.textContent = b.getAttribute("data-full");
        if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s1");
        if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s2");
      });
    }
    return { span: span, spanHtml: spanHtml, stripsHtml: stripsHtml, fit: fit };
  })();
  // The rider's body measurements, kept in this browser and shared with the
  // size guide on product pages and the collection pages (the same storage),
  // so they're only ever typed once. Body measurements only - never a
  // garment's own, never a bike cover's length.
  var RIDER = (function () {
    var KEY = "pmo.rider.v1";
    var AREAS = [
      ["hand length", /^(hand length|hand size)/], ["palm", /^(palm|hand circumference|hand girth|hand)/],
      ["chest", /^(chest|bust)/], ["waist", /^waist/], ["hips", /^(hips?|seat)/], ["thigh", /^(mid[- ]?thigh|thigh)/],
      ["inseam", /^(inseam|inside leg|leg length)/], ["head", /^head/], ["foot", /^(foot|feet)/], ["height", /^height/]
    ];
    function garment(label) {
      if (/palm|hand|head|foot/i.test(label || "")) return false;
      return /\bflat\b|width|armpit|\bof (a )?(jacket|garment|hoodie|tee|shirt|pants|jeans)\b/i.test(label || "");
    }
    function key(label) {
      if (garment(label)) return null;
      var a = String(label || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/\b(circumference|girth|measurement)\b/g, "").replace(/\s+/g, " ").trim();
      var parts = a.split(/\s*\/\s*/);
      for (var i = 0; i < parts.length; i++) {
        var t = parts[i].replace(/^(full|natural|lower|upper|true|body)\s+/, "");
        for (var j = 0; j < AREAS.length; j++) if (AREAS[j][1].test(t)) return AREAS[j][0];
      }
      return null;
    }
    function load() { try { var p = JSON.parse(localStorage.getItem(KEY) || "null"); return p && typeof p === "object" ? p : {}; } catch (e) { return {}; } }
    function ok(v) { v = Number(v); return isFinite(v) && v >= 5 && v <= 250 ? v : null; }
    // What we already have for this chart, field by field (null where we don't).
    function partial(calc) {
      if (!calc || calc.mode === "cover") return [];
      var m = load().meas || {};
      return calc.fields.map(function (f) { var k = key(f.label); return k ? ok(m[k]) : null; });
    }
    function full(calc) { var p = partial(calc); return p.length && p.every(function (v) { return v != null; }) ? p : null; }
    function remember(calc, cm) {
      if (!calc || calc.mode === "cover") return;
      var out = {};
      calc.fields.forEach(function (f, i) { var k = key(f.label), v = ok(cm[i]); if (k && v != null) out[k] = Math.round(v * 10) / 10; });
      if (!Object.keys(out).length) return;
      try { var p = load(); p.meas = Object.assign({}, p.meas || {}, out); p.at = Date.now(); localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {}
    }
    return { partial: partial, full: full, remember: remember };
  })();

  // ---------- cart, waitlist and fit consults ----------
  function money(cents) { var n = Number(cents) / 100; return isFinite(n) ? "$" + (n % 1 ? n.toFixed(2) : n.toFixed(0)) : ""; }
  function addBtn(id, label) { return '<button type="button" class="pmo-hc__btn pmo-hc__btn--terra" data-hc-add="' + esc(id) + '">' + esc(label) + "</button>"; }
  function waitBtn(id, label) { return '<button type="button" class="pmo-hc__btn pmo-hc__btn--terra" data-hc-wait="' + esc(id) + '" data-hc-label="' + esc(label) + '">Tell me when it\'s back</button>'; }
  function addToCart(btn) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = "Adding...";
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root.replace(/\/?$/, "/") + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-hc-add")), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        note("cart_add");
        btn.textContent = "Added to cart"; btn.classList.add("pmo-hc__btn--done"); btn.removeAttribute("data-hc-add");
        // The header's cart count and drawer catch up (the cart page itself reloads on this, so not there).
        if (!/^\/cart\/?$/.test(location.pathname)) document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
        var after = document.createElement("div");
        after.className = "pmo-hc__links";
        // data-pmg-dot: the header's cart-count badge leaves this link alone.
        after.innerHTML = '<a href="/cart" data-pmg-dot="1">View cart &rarr;</a><a href="/checkout">Checkout &rarr;</a>';
        btn.parentElement.appendChild(after); scroll();
      }, function (err) {
        btn.disabled = false; btn.textContent = label;
        bot("<p>" + esc((err && (err.description || err.message)) || "That didn't go into the cart - please try again.") + "</p>");
      });
  }
  // A sold-out choice: their email goes on the same Waitlist as the product
  // page's, and the shop emails them when it's back.
  function waitlistAsk(id, label) {
    S.awaiting = null; setPlace();
    var fid = "pmo-hc-w" + Date.now(), c = CFG.customer || {};
    return bot("<p><b>" + esc(label) + "</b> is sold out right now. Leave your email and we'll let you know as soon as it's back.</p>" +
      '<form class="pmo-hc__card pmo-hc__form" id="' + fid + '"><div class="pmo-hc__row2"><label>First name<input name="n" autocomplete="given-name" value="' + esc(c.first || "") + '"></label>' +
      '<label>Email<input name="e" type="email" autocomplete="email" required value="' + esc(c.email || S.waitEmail || "") + '"></label></div>' +
      '<button class="pmo-hc__btn pmo-hc__btn--terra" type="submit">Let me know</button></form>').then(function (m) {
      var form = m.querySelector("form"); if (!form) return;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = form.elements.e.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { form.elements.e.focus(); return; }
        snap(); form.querySelector("button[type=submit]").disabled = true;
        S.waitEmail = email;
        wait(api("/waitlist", { variant: id, email: email, firstName: form.elements.n.value.trim() })).then(function (r) {
          if (!r || r.error || r.enabled === false) throw r;
          note("waitlist");
          return bot("<p>You're on the list for <b>" + esc(label) + "</b>. We'll email " + esc(email) + " as soon as it's back.</p>").then(function () { chips(["A different product", "Something else"]); });
        }).catch(function () {
          return bot("<p>I couldn't add you to the list just now. Message the crew and we'll do it for you.</p>").then(function () { deadEnd(); });
        });
      });
      form.elements.e.focus();
    });
  }
  var CALENDLY = "https://calendly.com/peakmoto/15min";
  function bookConsult() {
    S.awaiting = null; setPlace();
    return bot('<div class="pmo-hc__card"><div class="pmo-hc__big">Free fit consult</div>' +
      '<ul class="pmo-hc__ticks"><li>15 minutes on Google Meet, from anywhere</li><li>We talk you through measuring, then recommend a size for the exact gear you want</li><li>We hold the gear up to the camera so you can see the cut and the armour</li><li>No pressure to buy anything</li></ul>' +
      '<div><button type="button" class="pmo-hc__btn pmo-hc__btn--terra" data-hc-book>Pick a time</button></div>' +
      '<div class="pmo-hc__sub">Rather try it on? Our shop is in Port Melbourne. We can hold an item for 1 day (anything except Pando Moto), or arrange a deposit-paid try-on with a deposit of 25% of the RRP.</div></div>', 0).then(function () {
      chips(["Arrange a hold or try-on", "Something else"], function (x) { if (x === "Arrange a hold or try-on") { S.lastUnanswered = "I'd like to arrange a hold or a deposit-paid try-on" + (S.lastProduct && S.size && S.size.p ? " for the " + S.size.p.title : "") + "."; return handoff(); } handle(x); });
    });
  }
  // Calendly's own booking window, with their name and email filled in when we have them.
  function openCalendly() {
    note("consult");
    var c = CFG.customer || {}, url = CALENDLY + "?hide_gdpr_banner=1" + (c.first ? "&name=" + encodeURIComponent(c.first) : "") + (c.email || S.waitEmail ? "&email=" + encodeURIComponent(c.email || S.waitEmail) : "");
    var go = function () { close(); window.Calendly.initPopupWidget({ url: url }); };
    if (window.Calendly && window.Calendly.initPopupWidget) return go();
    if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
      var l = document.createElement("link"); l.rel = "stylesheet"; l.href = "https://assets.calendly.com/assets/external/widget.css"; document.head.appendChild(l);
    }
    var done = false, s = document.createElement("script");
    s.src = "https://assets.calendly.com/assets/external/widget.js";
    s.onload = function () { if (!done && window.Calendly) { done = true; go(); } };
    document.head.appendChild(s);
    // If the booking window can't load here, the booking page opens instead.
    setTimeout(function () { if (!done) { done = true; window.open(CALENDLY, "_blank", "noopener"); } }, 5000);
  }
  log.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-hc-add], [data-hc-wait], [data-hc-book]");
    if (!b || b.disabled) return;
    if (b.hasAttribute("data-hc-add")) return addToCart(b);
    if (b.hasAttribute("data-hc-book")) return openCalendly();
    snap(); me("Tell me when it's back");
    waitlistAsk(b.getAttribute("data-hc-wait"), b.getAttribute("data-hc-label"));
  });

  // A one-line delivery estimate for a variant, filled in once it's known.
  function etaInto(box, v) {
    if (!box || !v) return;
    var mine = gen;
    api("/availability?variant=" + encodeURIComponent(v.id) + (S.postcode ? "&postcode=" + S.postcode : "")).then(function (r) {
      if (mine !== gen || !r || r.enabled === false || r.error) { box.remove(); return; }
      var st = STATE[r.state] || ["", r.state], when = "";
      if (r.delivery) when = (r.delivery.assumed ? "Standard to " + r.delivery.zoneLabel : "To " + S.postcode) + ": " + range(r.delivery.from, r.delivery.to);
      else if (r.state === "backorder") when = "We'll email a delivery date within one business day of ordering.";
      box.innerHTML = '<div class="pmo-hc__stock"><span class="pmo-hc__dot ' + (st[0] ? "pmo-hc__dot--" + st[0] : "") + '"></span>' + esc(st[1]) + "</div>" + (when ? '<div class="pmo-hc__sub">' + esc(when) + "</div>" : "");
      box.hidden = false;
      if (r.delivery && r.delivery.assumed) S.etaAssumed = true;
    }, function () { box.remove(); });
  }

  // ---------- complete the kit ----------
  // Gear that goes with this one (Shopify's related products), one of each
  // kind - a jacket for pants, gloves, boots, protection - sized from the
  // rider's measurements wherever the item has a size chart.
  var KINDS = [["protection", /\b(protectors?|armou?r|airbag)\b/i], ["base layer", /\b(base ?-?layer|mid-?layer|thermal)\b/i],
    ["jacket", /\b(jacket|vest|gilet|hoodie)\b/i], ["pants", /\b(pants|jeans|trousers|leggings|cargos?|chaps|overpants|shorts)\b/i],
    ["gloves", /\bgloves?\b/i], ["boots", /\b(boots?|shoes?|sneakers?)\b/i], ["helmet", /\bhelmet\b/i], ["suit", /\b(suit|one-piece)\b/i]];
  function kindOf(p) { var t = (p.title || "") + " " + (p.type || p.product_type || ""); for (var i = 0; i < KINDS.length; i++) if (KINDS[i][1].test(t)) return KINDS[i][0]; return null; }
  // Body zones armour covers, read from a product's "impact protection" list
  // ("CE Level 2 Hip Armour") or a protector's own name ("Hip Protectors").
  // A pocket for armour, or armour sold separately, isn't armour.
  var ZONES = [["hip", /\bhips?\b/i], ["knee", /\bknees?\b/i], ["back", /\bback\b/i], ["chest", /\bchest\b/i], ["shoulder", /\bshoulders?\b/i], ["elbow", /\belbows?\b/i]];
  function zonesIn(lines) {
    var out = {};
    (lines || []).forEach(function (l) {
      l = String(l || "");
      if (!/armou?r|protector|insert|pads?\b/i.test(l) || /pocket|ready|compatible|optional|sold separately|upgrade/i.test(l)) return;
      ZONES.forEach(function (z) { if (z[1].test(l)) out[z[0]] = 1; });
    });
    return out;
  }
  function protectionOf(fp) { var v = fp && fp.protection; if (typeof v === "string") { try { v = JSON.parse(v); } catch (e) { v = [v]; } } return Array.isArray(v) ? v : []; }
  function completeKit(p) {
    S.awaiting = null; setPlace();
    var pid = p.id || (CFG.product && CFG.product.handle === p.handle && window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id);
    if (!pid) return bot("<p>I can't pull up gear to go with that one right now. The crew are happy to put a kit together for you.</p>").then(function () { deadEnd(); });
    var mine = kindOf(p), model = (String(p.title || "").match(/^[A-Za-z]+/) || [""])[0].toLowerCase();
    var cart = fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; });
    var recs = fetch("/recommendations/products.json?product_id=" + encodeURIComponent(pid) + "&limit=10&intent=related").then(function (r) { return r.json(); });
    return wait(Promise.all([recs, cart])).then(function (got0) {
      var j = got0[0], inCart = got0[1].items || [];
      // Not what's already in their cart, nor more of a kind they've got there.
      var have = {}, seen = {};
      inCart.forEach(function (it) { have[it.handle] = 1; var k = kindOf({ title: it.product_title, type: it.product_type }); if (k && k !== "protection") seen[k] = 1; });
      if (mine) seen[mine] = 1;
      var list = (j.products || []).filter(function (x) { return x.handle !== p.handle && x.available && !have[x.handle] && kindOf(x); });
      // The same range first: the Sherrie Jacket with the Sherrie Leggings.
      list.sort(function (a, b) { return (b.title.toLowerCase().indexOf(model) === 0) - (a.title.toLowerCase().indexOf(model) === 0); });
      list = list.slice(0, 8);
      return Promise.all([Promise.all(list.map(function (x) { return loadProduct(x.handle).catch(function () { return null; }); })), calc().catch(function () { return null; })]).then(function (got) {
        var full = got[0], K = got[1], sized = 0, pick = [];
        // Armour this one already has (the Sherrie Leggings: hip and knee), so
        // no protectors for those; each pick adds its own (a jacket's back armour).
        var covered = zonesIn(protectionOf(p));
        list.forEach(function (x, i) {
          if (pick.length >= 3) return;
          var k = kindOf(x), fp = full[i];
          if (k === "protection") {
            var z = zonesIn([x.title].concat(protectionOf(fp)));
            var zs = Object.keys(z);
            if (!zs.length) z = zonesIn([x.title + " protector"]), zs = Object.keys(z);
            if (zs.length && zs.every(function (q) { return covered[q]; })) return;
            if (seen["protection:" + zs.join("+")]) return;
            seen["protection:" + zs.join("+")] = 1;
          } else {
            if (seen[k]) return;
            seen[k] = 1;
          }
          Object.keys(zonesIn(protectionOf(fp))).forEach(function (q) { covered[q] = 1; });
          pick.push([x, fp]);
        });
        if (!pick.length) return bot("<p>I haven't got anything to pair with the <b>" + esc(p.title) + "</b> right now. The crew are happy to put a kit together for you.</p>").then(function () { deadEnd(); });
        note("kit");
        var items = pick.map(function (pr) {
          var x = pr[0], fp = pr[1], line = "", btn = '<a class="pmo-hc__mini-link" href="' + esc(x.url) + '">View &rarr;</a>';
          var chart = fp && fp.chart && fp.chart.charts && fp.chart.charts.find(function (c) { return c.calc && c.calc.fields && c.calc.fields.length; });
          var known = chart && RIDER.full(chart.calc);
          if (known && K) {
            var c = chart.calc, t = chart.tables[c.table], size = c.mode === "cover" ? null : K.recommend(t, c, known, "regular").size;
            var v = size && variantFor(fp, size);
            if (size) { sized++; line = "Your size: <b>" + esc(size) + "</b>"; }
            if (v && v.available) btn = addBtn(v.id, "Add " + size) + btn;
            else if (v) line += " - sold out right now";
          } else if (fp && (fp.variants || []).length === 1 && fp.variants[0].available) {
            btn = addBtn(fp.variants[0].id, "Add to cart") + btn;
          } else if (chart) line = "Size it on its page";
          var img = x.featured_image ? '<img src="' + esc(String(x.featured_image).replace(/^\/\//, "https://") + (String(x.featured_image).indexOf("?") > -1 ? "&" : "?") + "width=160") + '" alt="" loading="lazy">' : '<span class="pmo-hc__kit-noimg"></span>';
          return '<div class="pmo-hc__kit-item">' + img + '<div><a href="' + esc(x.url) + '"><b>' + esc(x.title) + "</b></a>" +
            '<div class="pmo-hc__sub">' + money(x.price) + (line ? " &middot; " + line : "") + '</div><div class="pmo-hc__kit-btns">' + btn + "</div></div></div>";
        });
        var already = Object.keys(zonesIn(protectionOf(p)));
        return bot("<p>To go with the <b>" + esc(p.title) + "</b>" + (sized ? ", sized from your measurements" : "") + ":</p>" +
          '<div class="pmo-hc__card pmo-hc__kit">' + items.join("") + "</div>" +
          (already.length ? '<div class="pmo-hc__sub" style="margin-top:8px">The ' + esc(p.title) + " already " + (/s$/i.test(p.title) ? "have" : "has") + " " + esc(already.join(" and ")) + " armour, so no extra protectors for those.</div>" : ""), 0).then(function () { chips(["Message the crew", "Something else"]); });
      });
    }, function () { return bot("<p>I can't pull up gear to go with that one right now. Try again in a moment.</p>"); });
  }

  function sizeResult(sz, cm, K, unit, remembered) {
    var chart = sz.chart, c = chart.calc, table = chart.tables[c.table], p = sz.p;
    var size = null;
    if (c.mode === "cover") size = K.coverSize(table, c, cm).size;
    else size = K.recommend(table, c, cm, "regular").size;
    if (!size) {
      note("size_outside");
      return bot("<p>Your measurements sit outside this product's size range. The Peak Moto team can find you something that fits properly - a free fit consult is the quickest way.</p>").then(function () { deadEnd(["Book a free fit consult"]); });
    }
    note("size");
    if (remembered) note("size_remembered");
    var sp = c.mode === "cover" ? null : SG.span(K, table, c, cm, size);
    var detail = c.mode === "cover" ? "" : SG.stripsHtml(c, size, sp, table, cm, unit === "in" ? "in" : "cm") + SG.spanHtml(size, sp);
    var v = variantFor(p, size);
    var url = p.url + (v ? "?variant=" + v.id : "");
    var here = CFG.product && CFG.product.handle === p.handle;
    var used = remembered ? c.fields.map(function (f, i) { return String(f.label).toLowerCase().replace(/ circumference/, "") + " " + cm[i] + " cm"; }).join(", ") : "";
    var html = '<div class="pmo-hc__card"><div class="pmo-hc__sub">' + esc(p.title) + '</div><div class="pmo-hc__big">' + (remembered ? "You're an <em>" + esc(size) + "</em> in this" : "We\'d go with <em>" + esc(size) + "</em>") + "</div>" +
      (remembered ? '<div class="pmo-hc__sub">From the measurements you gave us earlier: ' + esc(used) + ".</div>" : "") +
      detail +
      (v && !v.available ? '<div class="pmo-hc__note">That size is sold out right now.</div>' : "") +
      (v && v.available ? '<div class="pmo-hc__eta" data-hc-eta hidden></div>' : "") +
      '<div class="pmo-hc__actions">' + (v && v.available ? addBtn(v.id, "Add " + size + " to cart") : v ? waitBtn(v.id, p.title + " - " + size) : "") +
      '<a class="pmo-hc__cta pmo-hc__cta--ghost" href="' + esc(url) + '">' + (here ? "Choose " + esc(size) + " on the page" : "View in " + esc(size)) + "</a></div>" +
      (document.querySelector("pmo-size-guide [data-sg-open]") && CFG.product && CFG.product.handle === p.handle ? '<button type="button" class="pmo-hc__chip" data-open-guide>Open the full size guide</button>' : "") +
      "</div>";
    S.eta = { product: p, variant: v ? v.id : null };
    if (c.mode !== "cover") RIDER.remember(c, cm);
    return bot(html, 0).then(function (m) {
      SG.fit(m);
      etaInto(m.querySelector("[data-hc-eta]"), v);
      // On this product's own page, choosing the size picks it right there
      // instead of reloading the page.
      var cta = m.querySelector(".pmo-hc__cta");
      if (cta && v && CFG.product && CFG.product.handle === p.handle) cta.addEventListener("click", function (e) {
        var picked = selectOnPage(p, v);
        if (!picked) return;
        e.preventDefault();
        // On a phone the chat covers the page: close it and show the size they now have.
        if (window.matchMedia && window.matchMedia("(max-width: 560px)").matches) {
          close();
          if (picked.scrollIntoView) picked.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        else { cta.textContent = size + " is selected"; cta.classList.add("pmo-hc__cta--done"); }
      });
      var g = m.querySelector("[data-open-guide]");
      if (g) g.addEventListener("click", function () { close(); document.querySelector("pmo-size-guide [data-sg-open]").click(); });
      var next = ["Complete the kit"].concat(S.postcode || !(v && v.available) ? [] : ["Add my postcode"], [remembered ? "Use different measurements" : "Measure again"], sp ? ["Book a free fit consult"] : [], ["Message the crew"]);
      chips(next, function (x) {
        if (x === "Add my postcode") { if (S.eta.variant) return askPostcode(); return pickVariant(p); }
        if (x === "Complete the kit") return completeKit(p);
        if (x === "Use different measurements") return askMeasure(S.size);
        handle(x);
      });
    });
  }

  // ---------- delivery date ----------
  function startEta() {
    if (CFG.product) return withProduct(CFG.product.handle, pickVariant);
    return askProductName("eta");
  }
  // One option at a time (colour, then size...), as buttons, so nobody has to
  // scroll a list of every combination. Each step only offers what exists
  // with the choices made so far.
  function pickVariant(p) {
    S.eta = { product: p, variant: null };
    var vs = p.variants || [], names = p.options || [];
    if (vs.length === 1) { S.eta.variant = vs[0].id; return askPostcode(); }
    // sold: they've picked something crossed out, so the end of this is the waitlist, not a date.
    var step = function (i, chosen, sold) {
      var fits = vs.filter(function (v) { return chosen.every(function (c, k) { return (v.options || [])[k] === c; }); });
      if (i >= names.length || fits.length === 1) {
        S.eta.variant = fits[0].id;
        if (sold || fits[0].available === false) return waitlistAsk(fits[0].id, p.title + (fits[0].title !== "Default Title" ? " - " + fits[0].title : ""));
        return askPostcode();
      }
      var vals = [];
      fits.forEach(function (v) { var x = (v.options || [])[i]; if (x != null && vals.indexOf(x) < 0) vals.push(x); });
      // A choice is sold out when nothing with it (and the choices so far) can be bought.
      var off = vals.map(function (x) { return !fits.some(function (v) { return (v.options || [])[i] === x && v.available !== false; }); });
      var allOff = off.every(Boolean);
      if (vals.length === 1) return step(i + 1, chosen.concat(vals), sold || allOff);
      var name = String(names[i] || "option").toLowerCase(), any = off.some(Boolean);
      var ask = allOff && !sold && i === 0 ? "<p>The <b>" + esc(p.title) + "</b> is sold out in every option right now. Pick the one you're after and we'll email you when it's back.</p>"
        : "<p>" + (i === 0 ? "Which " : "And which ") + esc(name === "title" ? "one" : name) + "?</p>" + (any && !sold ? '<div class="pmo-hc__sub">Crossed out = sold out. Tap one to hear when it\'s back.</div>' : "");
      return bot(ask, 0).then(function () {
        chips(vals.map(function (x, k) { return { label: x, off: off[k] }; }), function (x) { step(i + 1, chosen.concat([x.label]), sold || x.off); });
      });
    };
    return step(0, []);
  }
  function anotherLabel(p) {
    var o = (p.options || []).join(" ");
    return /size/i.test(o) ? "Try another size" : /colou?r/i.test(o) ? "Try another colour" : "Try another option";
  }
  function askPostcode() {
    if (S.postcode) return showEta(true);
    S.awaiting = "postcode"; setPlace("Postcode, e.g. 2000");
    return bot("<p>What's your postcode? I'll tell you when it'll hit your door.</p>").then(function () { chips(["Skip"], function () { S.awaiting = null; setPlace(); showEta(false); }); });
  }
  function postcode(t) {
    var pc = t.replace(/\D/g, "");
    if (pc.length === 3) pc = "0" + pc;
    if (pc.length !== 4) return bot("<p>That doesn't look like an Australian postcode - it's four numbers, like 3000.</p>");
    S.awaiting = null; setPlace(); S.postcode = pc; ss.set("postcode", pc);
    return showEta(false);
  }
  var STATE = {
    in_shop: ["", "In stock - ready to post"],
    supplier: ["blue", "Available to order - we bring it in from the brand"],
    incoming: ["amber", "On its way to us"],
    backorder: ["amber", "On backorder"],
    sold_out: ["red", "Sold out in this one"]
  };
  function showEta(remembered) {
    var e = S.eta, p = e.product, v = (p.variants || []).find(function (x) { return String(x.id) === String(e.variant); });
    var q = "/availability?variant=" + encodeURIComponent(e.variant) + (S.postcode ? "&postcode=" + S.postcode : "");
    return wait(api(q)).then(function (r) {
      if (!r || r.enabled === false || r.error) {
        return bot("<p>I can't work out a date for that one right now. In-stock orders are posted within one business day - the shipping page has the rest.</p>" + links([{ label: "Shipping & delivery", url: "/pages/shipping" }])).then(function () { deadEnd(); });
      }
      note("eta");
      var st = STATE[r.state] || ["", r.state];
      var rows = [];
      if (r.state === "incoming" && r.incoming && r.incoming.eta) rows.push(["Arriving with us", day(r.incoming.eta)]);
      if (r.dispatch && r.dispatch.date) rows.push([r.dispatch.estimated ? "Estimated dispatch" : "Posted", day(r.dispatch.date)]);
      if (r.delivery) {
        rows.push(["Standard to " + (r.delivery.assumed ? r.delivery.zoneLabel : S.postcode), range(r.delivery.from, r.delivery.to)]);
        if (r.delivery.express) rows.push(["Express" + (r.delivery.express.price ? " (" + r.delivery.express.price + ")" : ""), range(r.delivery.express.from, r.delivery.express.to)]);
      }
      if (r.collect && r.collect.from) rows.push(["Click & collect" + (r.collect.shop ? ", " + r.collect.shop : ""), day(r.collect.from)]);
      var cut = r.dispatch && r.dispatch.secondsToCutoff > 0 ? Math.round(r.dispatch.secondsToCutoff / 60) : 0;
      var html = '<div class="pmo-hc__card"><div class="pmo-hc__sub">' + esc(p.title) + (v && v.title !== "Default Title" ? " - " + esc(v.title) : "") + "</div>" +
        '<div class="pmo-hc__stock"><span class="pmo-hc__dot ' + (st[0] ? "pmo-hc__dot--" + st[0] : "") + '"></span>' + esc(st[1]) + "</div>" +
        (cut ? '<div class="pmo-hc__note pmo-hc__note--terra"><b>Order in the next ' + (cut >= 60 ? Math.floor(cut / 60) + "h " : "") + (cut % 60) + "m</b> and it's posted today.</div>" : "") +
        (rows.length ? '<div class="pmo-hc__dates">' + rows.map(function (x) { return "<div><span>" + esc(x[0]) + "</span><b>" + esc(x[1]) + "</b></div>"; }).join("") + "</div>" : "") +
        (r.delivery && r.delivery.assumed ? '<div class="pmo-hc__sub">Add your postcode for a date to your door.</div>' : remembered ? '<div class="pmo-hc__sub">Using your postcode ' + esc(S.postcode) + " from earlier.</div>" : "") +
        (r.state === "backorder" ? "<div>We don't have a date from the brand yet. Order now and we'll email your delivery date within one business day.</div>" : "") +
        (r.caveat ? '<div class="pmo-hc__note">' + esc(r.caveat) + "</div>" : "") +
        '<div class="pmo-hc__actions">' + (r.state === "sold_out" ? waitBtn(e.variant, p.title + (v && v.title !== "Default Title" ? " - " + v.title : "")) : v && v.available !== false ? addBtn(e.variant, "Add to cart") : "") +
        '<a class="pmo-hc__cta pmo-hc__cta--ghost" href="' + esc(p.url + "?variant=" + e.variant) + '">View this one</a></div></div>';
      return bot(html, 0).then(function () {
        chips((S.postcode ? ["Change postcode"] : []).concat((p.variants || []).length > 1 ? [anotherLabel(p)] : [], ["A different product", "Something else"]));
      });
    }, function () { return bot("<p>I can't work out a date right now. Please try again in a moment.</p>"); });
  }

  // ---------- message the crew ----------
  function subjectLine() {
    var ask = String(S.lastAsk || "").replace(/(?:#|\bpm\s?)\d{4,6}\b/ig, "").replace(/\s+/g, " ").replace(/\bi\b/g, "I").trim();
    var nice = ask ? ask.charAt(0).toUpperCase() + ask.slice(1) : "";
    return S.order ? "#" + S.order + " - " + nice : nice;
  }
  function transcript() {
    return Array.prototype.slice.call(log.querySelectorAll(".pmo-hc__msg")).slice(-14).map(function (m) {
      // Just the words: forms, buttons and photos left out, a space between paragraphs.
      var c = m.cloneNode(true);
      Array.prototype.forEach.call(c.querySelectorAll("form, button, img, .pmo-hc__links"), function (x) { x.remove(); });
      Array.prototype.forEach.call(c.querySelectorAll("p, li, div, span"), function (x) { x.appendChild(document.createTextNode(" ")); });
      var text = c.textContent.replace(/\s+/g, " ").trim();
      return text ? (m.classList.contains("pmo-hc__msg--me") ? "Customer: " : "Chat: ") + text.slice(0, 300) : "";
    }).filter(Boolean).join("\n");
  }
  function handoff() {
    S.awaiting = null; setPlace();
    var id = "pmo-hc-h" + Date.now(), c = CFG.customer || {};
    return bot("<p>Easy. Leave your details and the crew will email you back within one business day.</p>" +
      '<form class="pmo-hc__card pmo-hc__form" id="' + id + '"><div class="pmo-hc__row2"><label>First name<input name="n" autocomplete="given-name" required value="' + esc(c.first || "") + '"></label>' +
      '<label>Email<input name="e" type="email" autocomplete="email" required value="' + esc(c.email || "") + '"></label></div>' +
      '<label>Subject<input name="s" maxlength="160" value="' + esc(subjectLine()) + '"></label>' +
      '<label>Anything else we should know?<textarea name="q" rows="3">' + esc(S.lastUnanswered || "") + "</textarea></label>" +
      '<button class="pmo-hc__btn pmo-hc__btn--terra" type="submit">Send to the crew</button><span class="pmo-hc__hint">This chat goes with it, so you won\'t have to repeat yourself.</span></form>').then(function (m) {
      var form = m.querySelector("form"); if (!form) return;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var f = form.elements, q = f.q.value.trim() || f.s.value.trim();
        if (!q) { f.q.focus(); return; }
        snap(); form.querySelector("button").disabled = true;
        me("Sent: " + (f.s.value.trim() || q));
        wait(api("/help/message", { name: f.n.value.trim(), email: f.e.value.trim(), order: S.order, subject: f.s.value.trim(), question: q, transcript: transcript(), page: CFG.page })).then(function (r) {
          if (r && r.ok) return bot(r.html || "<p>Thanks, that's with the crew now.</p>", 0).then(function () { deadEnd(null, true); });
          form.querySelector("button").disabled = false;
          return bot("<p>" + esc((r && r.error) || "That didn't send - mind trying again?") + "</p>");
        }, function () { form.querySelector("button").disabled = false; return bot("<p>That didn't send - mind trying again? Or email hello@peakmotogear.com.au.</p>"); });
      });
    });
  }

  // ---------- keep the chat across pages ----------
  // The conversation is kept for this visit, so following a link in the chat
  // and coming back to it carries on where it left off instead of starting over.
  function save() {
    try {
      var kids = Array.prototype.slice.call(log.children).filter(function (n) { return !n.classList.contains("pmo-hc__typing"); }).slice(-40);
      sessionStorage.setItem("pmo.hc.log", JSON.stringify({ html: kids.map(function (n) { return n.outerHTML; }).join(""), order: S.order, at: Date.now() }));
    } catch (e) {}
  }
  var saveT;
  if (window.MutationObserver) new MutationObserver(function () { clearTimeout(saveT); saveT = setTimeout(save, 250); }).observe(log, { childList: true, subtree: true, attributes: true });
  function restore() {
    var saved = ss.get("log");
    if (!saved || !saved.html || Date.now() - saved.at > 6 * 3600000) return false;
    log.innerHTML = saved.html;
    // Only one "welcome back" at a time: drop the last one if nothing came after it.
    var last = log.querySelectorAll("[data-hc-back]"), w = last.length && last[last.length - 1].closest(".pmo-hc__msg");
    if (w && log.children.length - Array.prototype.indexOf.call(log.children, w) <= 2) { while (log.lastElementChild !== w) log.lastElementChild.remove(); w.remove(); }
    // Earlier buttons and forms belonged to the last page; the new options below take over.
    log.querySelectorAll(".pmo-hc__chips").forEach(function (c) { c.classList.add("pmo-hc__chips--used"); });
    log.querySelectorAll("form input, form select, form textarea, form button").forEach(function (x) { x.disabled = true; });
    if (saved.order) S.order = saved.order;
    scroll();
    bot("<p data-hc-back>Welcome back! What's next?</p>", 150).then(function () { chips(homeChips()); });
    return true;
  }
  // On a phone the chat covers the page, so a link in it closes the chat and
  // the page they asked for shows; the conversation is there when they reopen it.
  log.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[href]");
    if (a && window.matchMedia && window.matchMedia("(max-width: 560px)").matches) ss.set("open", false);
  });

  // Settings -> Chat Bot in PMO. Asked once every few minutes per visit; only
  // an explicit "off" hides the chat, so a slow or missing answer never does.
  function whenOn(go) {
    var c = ss.get("on");
    if (c && Date.now() - c.at < 300000) { if (c.v) go(); return; }
    fetch(P + "/help/status", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (j) {
        var on = !(j && j.enabled === false);
        ss.set("on", { v: on, at: Date.now() });
        if (on) go();
      });
  }
  whenOn(function () {
    root.classList.remove("pmo-hc--off");
    addEntries();
    if (ss.get("open")) open();
  });
})();
